'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('WidgetProjectTeamAddUser', WidgetProjectTeamAddUser);

  WidgetProjectTeamAddUser.$inject = ['Project', '$scope', 'Labels', 'errorMessageService',
    '$mdDialog', 'ProjectDataservice', 'User', 'project', 'tenantUsers'];

  function WidgetProjectTeamAddUser(ProjectAPI, $scope, Labels, errorMessageService,
    $mdDialog, ProjectDataservice, User, project, tenantUsers) {

    $scope.LABELS = Labels;
    /**
     *
     *
     * @param {Object} user - object containing the user information
     */

    $scope.addUserToProject = (user) => {

      if (existingUser(user._id)) {
        $scope.project.users.filter((projectUser) => {
          if (projectUser.userId._id === user._id) {
            projectUser.active = !projectUser.active;
          }
        });
      } else {
        const userObject = {
          active: true,
          deleted: false,
          projectRole: defineUserProjectRole(user),
          userId: user
        };

        $scope.project.users = [...$scope.project.users, userObject];
      }

      $scope.closeDialog(addSelectedUser());
    };

    /**
     * Add the selected user in the project ()
     *
     * @param {Object} user user data
     */
    const addSelectedUser = () => {
      userApiCall($scope.project.users, $scope.LABELS.getLabel('projectuseradded'));
      return $scope.project.users;
    };

    /**
     * Api call function to update the project
     *
     * @param {Object} users object containing all the users who are part of the project
     */
    const userApiCall = (users, successMsg) => {
      const data = {
        project: {
          users,
        },
        _id: $scope.project._id,
        versionId: $scope.project.versionId,
      };

      return ProjectAPI.editProject(data).$promise.then((updatedProject) => {
        $scope.project = updatedProject;
        errorMessageService.showSuccess(successMsg);
      });
    };

    /**
     * Any user added to a projects needs to have a defined projectRole
     *
     * @param {Object} users object containing all the users who are part of the project
     */
    const defineUserProjectRole = (user) => {
      if ($scope.project.users.length === 0) {
        return 'manager';
      }

      if (user.role === 'guest') {
        return 'guest';
      } else if (user.role === 'admin') {
        return 'manager';
      }

      return 'contributor';
    };

    /**
     * Compare the selected ID with the project users object.
     *
     * @param {Object} object containing all the users who are part of the project
     * @param {String} id contains the users id
     */
    const existingUser = (id) => $scope.project.users.some((user) => (user.userId._id === id));

    $scope.closeDialog = (updatedProject) => {
      $mdDialog.hide(updatedProject);
    };

    $scope.$onInit = () => {
      $scope.usersList = [];
      $scope.project = project;

      tenantUsers[0].then((resp) => {
        for (const user of resp) {
          $scope.project.users.find((projectUser) => {
            if ((projectUser.userId._id === user._id) && projectUser.active) {
              return user.projectStatus = true;
            } else {
              return user.projectStatus = false;
            }
          });

          $scope.usersList.push(user);
        }
      });
    };

    $scope.$onInit();
  }
})();
